var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoRsvp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 19,
    viewBox: "0 0 20 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.4348 0.103119C19.4348 0.103119 12.4366 -0.329765 6.81757 7.15819C2.50528 12.9035 0.857705 18.1894 0.857705 18.1894L2.64815 17.2966C3.99871 15.0228 4.69879 14.0879 6.00921 12.7579C8.31909 13.4672 10.74 13.4171 12.8715 11.0162C11.0452 10.4784 9.57704 10.5779 7.41096 10.769C9.86212 9.14245 11.526 8.79803 13.8126 9.19534L14.7537 7.37444C13.108 7.04072 12.0085 6.99849 10.372 7.35245C12.1947 6.10257 13.46 5.40445 15.6948 5.55354L16.8276 3.79938C15.3991 3.67942 14.5354 3.8237 12.8893 4.20503C14.3829 2.88658 15.7384 2.29967 17.7015 2.20677C17.7015 2.20677 18.6871 0.487311 19.4348 0.103119Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoRsvp);
export default __webpack_public_path__ + "static/media/logo-rsvp.71d2eca071b08de29c6c837c26672121.svg";
export { ForwardRef as ReactComponent };